export const SET_TABS = "SET_TABS";

export const SET_WINDOW_SIZE = "SET_WINDOW_SIZE";
